import { getPersistenceData, removePersistenceData, setPersistenceData } from "./persistenceStorage";
import { systemMessageStream } from "./systemPubSub";
import { filter, first, map } from "rxjs/operators";

const SiteCookieKey = "Site";

export function getDomainSite() {
    return getPersistenceData(SiteCookieKey);
}

export function setDomainSite(site) {
    setPersistenceData(SiteCookieKey, site);
}

export function removeDomainSite() {
    removePersistenceData(SiteCookieKey);
}

export const siteIdResolver = () => {
    const store = require("../store");
    if (_.get(store, "state.site.site._id")) {
        return Promise.resolve(_.get(store, "state.site.site._id"));
    } else {
        return systemMessageStream
            .pipe(
                filter((x) => {
                    return x.type === "site-id-collected";
                }),
                map((x) => x.payload.siteId),
                first()
            )
            .toPromise();
    }
};



// WEBPACK FOOTER //
// ./src/utils/site.js